import React from 'react';
import { services, travelCategories } from '../data/mock';
import { MapPin, Plane, Route, Calendar, Users, Building, Car, PlaneTakeoff, Navigation, Church, Mountain, Heart, Briefcase, PartyPopper } from 'lucide-react';

const iconMap = {
  MapPin, Plane, Route, Calendar, Users, Building, Car, PlaneTakeoff, Navigation, Church, Mountain, Heart, Briefcase, PartyPopper
};

const ServicesSection = () => {
  return (
    <section id="services" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Services */}
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1 bg-amber-100 text-amber-700 rounded-full text-sm font-medium mb-4">
            Our Services
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
            Complete Travel Solutions
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto">
            No matter the distance or group size, we provide the right vehicle for your journey.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div 
                key={service.id}
                className="group flex items-start gap-4 p-6 bg-gradient-to-br from-slate-50 to-white rounded-2xl border border-slate-100 hover:border-amber-200 hover:shadow-lg hover:shadow-amber-100/50 transition-all duration-300"
              >
                <div className="flex-shrink-0 w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center group-hover:bg-amber-500 transition-colors duration-300">
                  {IconComponent && <IconComponent className="w-6 h-6 text-amber-600 group-hover:text-white transition-colors duration-300" />}
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-slate-800 group-hover:text-amber-600 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-slate-500 text-sm mt-1">
                    Professional and reliable service for all your needs.
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Travel Categories */}
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-br from-amber-500 to-amber-600 rounded-3xl" />
          <div className="relative p-8 md:p-12">
            <div className="text-center mb-10">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
                Travel Services We Cover
              </h3>
              <p className="text-amber-100">
                Flexible travel solutions tailored to your needs.
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {travelCategories.map((category) => {
                const IconComponent = iconMap[category.icon];
                return (
                  <div 
                    key={category.id}
                    className="group flex flex-col items-center gap-3 p-5 bg-white/10 backdrop-blur-sm rounded-2xl hover:bg-white/20 transition-all duration-300 cursor-pointer"
                  >
                    <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center group-hover:bg-white/30 transition-colors">
                      {IconComponent && <IconComponent className="w-7 h-7 text-white" />}
                    </div>
                    <span className="text-white text-sm font-medium text-center">
                      {category.title}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
